/* eslint-disable */
import React, { useMemo } from 'react';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import { Spin } from 'antd';
import _, { isEmpty } from 'lodash';
import { formatNumber } from '../leaseRecordTable';
import LightTable from './LeaseUtils/LightTable';

const LeaseDetailsShowAll = ({ responseData, isLoading = false }) => {
	// const [rowSelection, setRowSelection] = useState([]);
	// const [isLoading, setIsLoading] = useState(true);
	// useEffect(() => {
	// 	// simulate data load or put this inside a callback after data loads
	// 	const timeout = setTimeout(() => {
	// 		setIsLoading(false);
	// 	}, 2000);

	// 	return () => clearTimeout(timeout); // cleanup
	// }, []);
	const columnData = useMemo(
		() => [
			{
				id: 'recordDocId',
				width: '5%',
				align: 'center',
				accessor: (data) => data?.latestProcessGroup?.recordDocId,
				cellAlign: 'center',
				Header: 'Document No',
				cellSx: { fontSize: '13px' },
			},
			{
				id: 'recordInputDate',
				width: '5%',
				align: 'center',
				accessor: (data) => {
					return dayjs(data?.latestProcessGroup?.recordInputDate?.dateString).format('YYYY-MM-DD');
				},
				cellAlign: 'center',
				Header: 'Document Date',
				cellSx: { fontSize: '13px' },
			},

			{
				id: 'referenceId',
				width: '5%',
				align: 'center',
				accessor: (data) => data?.latestProcessGroup?.serialNumber,
				cellAlign: 'center',
				Header: 'Reference Id',
				cellSx: { fontSize: '13px' },
			},
			{
				id: 'recordCreationDateTime',
				width: '5%',
				align: 'center',
				accessor: (data) => {
					return dayjs(data?.latestProcessGroup?.creationDateTime?.dateString).format('YYYY-MM-DD');
				},
				cellAlign: 'center',
				Header: 'Reference Date',
				cellSx: { fontSize: '13px' },
			},
			{
				id: 'description',
				width: '5%',
				align: 'left',
				accessor: (data) => data?.description,
				cellAlign: 'left',
				Header: 'Description',
				cellSx: { fontSize: '13px' },
			},
			{
				id: 'processStatus',
				width: '5%',
				align: 'center',
				accessor: (data) => data?.latestProcessGroup?.processStatus,
				cellAlign: 'center',
				Header: 'Type',
				cellSx: { fontSize: '13px' },
			},

			{
				id: 'total',
				width: '5%',
				align: 'right',
				accessor: 'total',
				cellAlign: 'center',
				Header: 'Amount',
				Cell: (cell) => {
					const debit = cell?.row?.original?.debit ? parseFloat(cell?.row?.original?.debit) : 0;
					const credit = cell?.row?.original?.credit ? parseFloat(cell?.row?.original?.credit) : 0;
					const total = isNaN(debit) ? 0 : debit - (isNaN(credit) ? 0 : credit);

					return (
						<Typography align="right" sx={{ fontSize: '13px !important' }}>
							{total !== 0 ? (total > 0 ? formatNumber(total, 2) : '(' + formatNumber(Math.abs(total), 2) + ')') : ''}
						</Typography>
					);
				},
			},

			{
				id: 'comulativeAmount',
				width: '5%',
				align: 'right',
				accessor: 'comulativeAmount',
				cellAlign: 'right',
				Header: 'Cumulative Amount',
				cellSx: { fontSize: '13px' },
			},
		],
		[]
	);

	const headSequence = [
		'Right of Use Asset',
		'Lease Liability',
		'Prepaid Rent',
		'Lease Payable',
		'Interest Expense',
		'Lease Expense',
		'Depreciation',
		'Accumulated Depreciation',
		// 'Bank',
	];

	const groupDataByHead = (data) => {
		if (!Array.isArray(data)) return null;

		// First, group the data by the 'head' field
		const grouped = _.groupBy(data, 'head');

		// Create an ordered result based on headSequence
		const result = headSequence
			.filter((head) => grouped[head]) // Only include heads that exist in the data
			.map((head) => {
				const values = grouped[head];
				let runningTotal = 0;

				// Calculate running totals and format data
				const indexedValues = values.map((item, index) => {
					const { head, ...rest } = item;

					// Calculate the value for this row (debit - credit)
					const debit = parseFloat(item.debit || 0);
					const credit = parseFloat(item.credit || 0);
					const rowValue = debit - credit;

					// Update running total
					runningTotal += rowValue;

					// Format the cumulative amount
					const formattedCumulative =
						runningTotal !== 0
							? runningTotal > 0
								? formatNumber(runningTotal, 2)
								: '(' + formatNumber(Math.abs(runningTotal), 2) + ')'
							: '';

					return {
						...rest,
						index,
						comulativeAmount: formattedCumulative,
					};
				});

				return {
					head,
					value: indexedValues,
				};
			});

		return result;
	};
	const filteredData = responseData?.filter((item) => item?.cancelStatus?.toLowerCase() !== 'cancelled');

	const groupedData = useMemo(() => groupDataByHead(filteredData), [filteredData]);

	return (
		<Box>
			<Spin spinning={isLoading || groupedData === null} style={{ maxHeight: '100%' }}>
				<div className="lease-details-tables">
					{Array.isArray(groupedData) && groupedData.length > 0 && !isLoading
						? groupedData.map((group, groupIndex) => (
								<div key={groupIndex}>
									<Typography
										variant="h6"
										sx={{ fontSize: '16px !important', fontWeight: 500, color: '#000000', mb: '10px', pl: '11px' }}
									>
										{group.head}
									</Typography>
									<div className="head-group-table" style={{ marginBottom: '30px' }}>
										<LightTable
											data={isEmpty(group.value) ? [] : group.value}
											columns={columnData}
											emptyMessage="No data available for this head"
											headerCellSx={{
												backgroundColor: '#EDF7FF !important',
												color: 'black',
												fontWeight: 500,
												height: '3.5rem',
												padding: '0.75rem',
											}}
											tableContainerSx={{
												border: '1px solid #b5b5b5',
												borderRadius: '4px',
												fontsize: '13px',
												// mb: 2,
												'& .MuiTableHead-root th': {
													backgroundColor: '#EDF7FF !important',
													color: '#000000',
												},
											}}
										/>

										{/* <Divider /> */}
									</div>
									{/* </CardAccordion> */}
								</div>
							))
						: responseData?.length === 0 &&
							groupedData?.length === 0 &&
							!isLoading && (
								<div style={{ textAlign: 'center', margin: '20px' }}>
									<Typography>No lease data available</Typography>
								</div>
							)}
				</div>
			</Spin>
		</Box>
	);
};

export default LeaseDetailsShowAll;
